import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SelectDropDownComponent } from './select-drop-down.component';

const COMPONENTS = [SelectDropDownComponent];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, CommonModule, IonicModule, FormsModule, ReactiveFormsModule],
  exports: [...COMPONENTS],
})
export class SelectDropDownModule {}
